import { render, staticRenderFns } from "./ModalEditOwnerSeller.vue?vue&type=template&id=e0bd626e&scoped=true"
import script from "./ModalEditOwnerSeller.vue?vue&type=script&lang=js"
export * from "./ModalEditOwnerSeller.vue?vue&type=script&lang=js"
import style0 from "./ModalEditOwnerSeller.vue?vue&type=style&index=0&id=e0bd626e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bd626e",
  null
  
)

export default component.exports